import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { catchError, map } from 'rxjs/operators';
import { of, Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { appConfig, AuthGaurdService } from './auth-gaurd.service';
import { UploadJsonModel } from '../models/commissionsummary/upload-json.model';
import { UploadJsonHeadersModel } from '../models/commissionsummary/upload-json-headers.model';

@Injectable({
  providedIn: 'root'
})
export class UploadJsonService {
  public uploadJsonModel = new UploadJsonModel();
  private host = environment.apiUrl + "commsumm/upload";
  public loggedinUser: string = '';
  mySalesChannelSet = new Set<string>();
  opts = [];

  constructor(private http: HttpClient,
    private logger: LoggerService, private authGaurdService: AuthGaurdService) {
    this.loggedinUser = this.authGaurdService.loginUser();
    console.log('MyDocsService login name ', this.loggedinUser);
  }

  public getReportTypes(): Observable<UploadJsonModel[]> {
    return this.http.get<UploadJsonModel[]>(`${this.host}/getreporttypes`);
  }

  public getKpis(): Observable<UploadJsonModel[]> {
    return this.http.get<UploadJsonModel[]>(`${this.host}/getkpis`);
  }

  public getComPlans(): Observable<UploadJsonModel[]> {
    return this.http.get<UploadJsonModel[]>(`${this.host}/getcomplans`);
  }

  public getCommPlanAndKpis(id: number): Observable<UploadJsonModel[]> {
    return this.http.get<UploadJsonModel[]>(`${this.host}/getcommplanandkpis/` + id);
  }

  public fetchHeaders(id: number): Observable<UploadJsonHeadersModel[]> {
    return this.http.get<UploadJsonHeadersModel[]>(`${this.host}/getheaders/` + id);
  }

  public fetchButtons(id: number): Observable<UploadJsonHeadersModel[]> {
    return this.http.get<UploadJsonHeadersModel[]>(`${this.host}/getbuttons/` + id);
  }

  public updateHeaders(headersEditModels: UploadJsonHeadersModel[]): Observable<UploadJsonHeadersModel[]> {
    return this.http.post<UploadJsonHeadersModel[]>(`${this.host}/updateheaders`, headersEditModels);
  }

  public updateButtons(buttonsEditModels: UploadJsonHeadersModel[]): Observable<UploadJsonHeadersModel[]> {
    return this.http.post<UploadJsonHeadersModel[]>(`${this.host}/updatebuttons`, buttonsEditModels);
  }

  public deleteEmp(id: number): Observable<CustomHttpRespone> {
    return this.http.delete<CustomHttpRespone>(`${this.host}/deleteemp/${id}`);
  }

  public getJsonsList1() {
    this.opts = [];
    let url = this.host + '/getjsonslist';
    return this.opts.length ?
      of(this.opts) :
      this.http.get<any>(url).pipe(tap(data => this.opts = data))
  }

  public getJsonsList(salesChannels: string, commPlanId: number) {
    const cacheBust = Date.now();
    let url = this.host + '/getjsonslist/' + salesChannels + "/" + commPlanId + '?_=' + cacheBust;
    return this.http.get<UploadJsonModel[]>(url, {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      })
    })
      .pipe(
        map((data: UploadJsonModel[]) => {
          return data;

        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getCommPlans(saleschannel: string) {
    let url = this.host + '/getcommplans/' + saleschannel;
    return this.http.get<UploadJsonModel[]>(url)
      .pipe(
        map((data: UploadJsonModel[]) => {
          return data;

        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }



  public updateDocs(myDocsModel: UploadJsonModel[]) {
    let url = this.host + '/updatedocs';
    let body = myDocsModel ? JSON.stringify(myDocsModel) : '';
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public getMyDocsList() {
    let url = this.host + '/getmydocslist';
    return this.http.get<UploadJsonModel[]>(url)
      .pipe(
        map((data: UploadJsonModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public filterUserDocByEmp(empId: string) {
    let url = this.host + '/filteruserdocbyemp/' + empId;
    return this.http.get<UploadJsonModel[]>(url)
      .pipe(
        map((data: UploadJsonModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getSalesChannels() {
    let url = this.host + '/getsaleschannelslist';
    return this.http.get<UploadJsonModel[]>(url)
      .pipe(
        map((data: UploadJsonModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  uploadJSON(file: File, gridName: string, sql: string, pageName: string, orderBy: number,  kpiId: number, report_type: string, description: string,commPlanId : number,salesChannel:string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    var kpiIdStr: string;
    var field_valueStr: string;
    var commPlanIdStr: string;

   console.log(kpiId);
   console.log(commPlanId);

    if (!kpiId) {
      kpiIdStr = "0";
    }else{
      kpiIdStr = kpiId.toString();
    }

    if (!commPlanId) {
      commPlanIdStr = "0";
    }else{
      commPlanIdStr = commPlanId.toString();
    }

    console.log(kpiIdStr);
   
    if (!report_type) {
      field_valueStr = "NA";
    }else{
      field_valueStr = report_type;
    }

    //formData.append('file', file);
    formData.append('pageName', pageName);
    formData.append('description', description);
    formData.append('gridName', gridName);
    formData.append('orderBy', orderBy.toString());
    formData.append('sql', sql);
    formData.append('kpiId', kpiIdStr);
    formData.append('comm_plan_id', commPlanIdStr);
    formData.append('report_type', field_valueStr);
    formData.append('current_user', this.loggedinUser);
    formData.append('salesChannel', salesChannel);

    const req = new HttpRequest('POST', `${this.host}/uploadjsons`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  updateJSON(file: File, gridName: string, sql: string, pageName: string, orderBy: number, commPlanId: number, salesChannel: string, kpiId: number, id: number): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    console.log("file === " + file);

    var copid: string;
    var kid: string;
    if (commPlanId == null) {
      copid = "0";
    } else {
      copid = commPlanId.toString();
    }

    if (kpiId == null) {
      kid = "0";
    } else {
      kid = kpiId.toString();
    }

    formData.append('file', file);
    formData.append('gridName', gridName);
    formData.append('sql', sql);
    formData.append('pageName', pageName);
    formData.append('orderBy', orderBy.toString());
    formData.append('commPlanId', copid);
    formData.append('kpiId', kid);
    formData.append('salesChannel', salesChannel);
    formData.append('id', id.toString());
    formData.append('current_user', this.loggedinUser);

    const req = new HttpRequest('PUT', `${this.host}/updatejsons`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  updateJSONWithoutFile(gridName: string, sql: string, pageName: string, orderBy: number, commPlanId: any, salesChannel: string, kpiId: any, id: number): Observable<HttpEvent<any>> {
    console.log("Service updateJSONWithoutFile() called");
    const formData: FormData = new FormData();

    var copid: string;
    var kid: string;
    if (commPlanId == null) {
      copid = "0";
    } else {
      copid = commPlanId.toString();
    }

    if (kpiId == null) {
      kid = "0";
    } else {
      kid = kpiId.toString();
    }

    formData.append('gridName', gridName);
    formData.append('sql', sql);
    formData.append('pageName', pageName);
    formData.append('orderBy', orderBy.toString());
    formData.append('commPlanId', copid);
    formData.append('kpiId', kid);
    formData.append('salesChannel', salesChannel);
    formData.append('id', id.toString());
    formData.append('current_user', this.loggedinUser);

    const req = new HttpRequest('PUT', `${this.host}/updatejsonswithoutfile`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  cloneData(sc: string, commId: number, commPlanId: number, salesChannel: string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    var copid: string;
    if (commPlanId == null) {
      copid = "0";
    } else {
      copid = commPlanId.toString();
    }

    console.log("commId === " + commId);
    console.log("sc === " + sc);

    console.log("commPlanId === " + copid);
    console.log("salesChannel === " + salesChannel);

    formData.append('commId', commId.toString());
    formData.append('sc', sc);

    formData.append('commPlanId', copid);
    formData.append('salesChannel', salesChannel);
    formData.append('current_user', this.loggedinUser);

    const req = new HttpRequest('POST', `${this.host}/clonedata`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

 

  public assignDocToEmployees(myDocsModel: UploadJsonModel[]) {
    let url = this.host + '/assigndoctoemployees';
    let body = myDocsModel ? JSON.stringify(myDocsModel) : '';
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  uploadSingleDoc(file: File, id: any): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    console.log("file === " + file);
    formData.append('file', file);
    formData.append('id', id);

    const req = new HttpRequest('PUT', `${this.host}/updatesingledoc`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }



  public getAssignedDocsList(doc_desc: string) {
    let url = this.host + '/getassigneddocslist/' + doc_desc;
    return this.http.get<UploadJsonModel[]>(url)
      .pipe(
        map((data: UploadJsonModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getEmployees(user_type: string) {
    let url = this.host + '/getemployeelist/' + user_type;
    return this.http.get<UploadJsonModel[]>(url)
      .pipe(
        map((data: UploadJsonModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }



  public getUserTypesList() {
    let url = this.host + '/getusertypeslist';
    return this.http.get<UploadJsonModel[]>(url)
      .pipe(
        map((data: UploadJsonModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public saveDocs(myDocsModel: UploadJsonModel[]) {
    let url = this.host + '/savedocs';
    let body = myDocsModel ? JSON.stringify(myDocsModel) : '';
    return this.http.post(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

 

  public handleError(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}

